@use "../../styles/breakpoint.module.scss" as *;

.nav {
    --extras-width: 75px;

    position: sticky;
    top: 0;
    height: var(--main-nav-height);
    background-color: var(--white);
    border-bottom: 1px solid var(--white-gray);
    z-index: 10;

    // set to 12 with PDP nav's value of 11 in mind
    &.navOpen {
        z-index: 12;
    }
}

.homePage {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 140px;
    height: var(--main-nav-height);
    z-index: 1;

    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    @media ($below-mobile) {
        width: 115px;
    }
}

.l1NavBase {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    gap: 32px;
    padding-right: var(--extras-width);
    transition: opacity 0.2s;
    background-color: var(--white);
}

.l1Nav {
    composes: l1NavBase;
    composes: container from "../../styles/composable/layout.module.css";
    gap: 8px;
}

.l1NavMobile {
    --l1-padding-block: 16px;

    composes: l1NavBase;
    flex-direction: column;
    padding: var(--l1-padding-block) var(--labui-container-margin);
    gap: 0;
    height: calc(100vh - var(--main-nav-height));
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.hideL1Nav {
    display: none;
}

.extras {
    width: var(--extras-width);
    position: absolute;
    right: 0;
    top: -1px;
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: flex-end;
    height: var(--main-nav-height);
    margin-right: var(--labui-container-margin);
    transition: opacity 0.2s;
}

.extraClickable {
    width: 24px;
    height: 24px;

    svg {
        width: 16px;
        height: 16px;
    }
}

.extraClickableFilled {
    composes: extraClickable;
    fill: var(--red);
}

.mobileMenuControl {
    display: inline-flex;
    align-items: center;
    height: var(--main-nav-height);
    margin-left: var(--labui-container-margin);
    transition: opacity 0.2s;

    &.layoutUnset {
        position: absolute;
    }
}

.hideMobileMenuControl {
    display: none;
}

.mobileMenuClickable {
    --width: var(--spacer-32);

    width: var(--width);
    height: var(--width);
    fill: var(--black);
}

.layoutUnset {
    opacity: 0;
}

.layoutSet {
    opacity: 1;
}

.spacer {
    flex-grow: 1;
    pointer-events: none;
}

// Pulled this from react-aria's docs.
.popover {
    --background-color: var(--white);
    --border-color: var(--gray);

    max-width: 350px;

    .overlayArrow svg {
        display: block;
        fill: var(--background-color);
        stroke: var(--border-color);
        stroke-width: 1px;
        translate: 0 1px;
    }

    &[data-placement="bottom"] {
        &:has(.overlayArrow) {
            margin-top: 6px;
        }

        .overlayArrow svg {
            transform: rotate(180deg);
        }
    }

    &[data-placement="top"] {
        .overlayArrow svg {
            transform: rotate(0deg);
            translate: 0 -1px;
        }
    }
}

.searchDialog,
.favoritesDialog {
    composes: outline from "../../styles/composable/utility.module.css";
}

.searchForm,
.favoritesList {
    background-color: var(--background-color);
    padding: var(--spacer-24);
    border: 1px solid var(--border-color);
}
